"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IArchiveType = void 0;
var IArchiveType;
(function (IArchiveType) {
    IArchiveType["zip"] = "zip";
    IArchiveType["tar.gz"] = "tar.gz";
    IArchiveType["tar.bz2"] = "tar.bz2";
})(IArchiveType = exports.IArchiveType || (exports.IArchiveType = {}));
